export default {"src":"/_next/static/media/modern-square-meters.276068af.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};